// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :root {
    --navy: #1e3a8a;
    --navy-2: #1e40af;
    --indigo: #4f46e5;
    --indigo-2: #6366f1;
    --soft: #f8fafc;
    --line: #e2e8f0;
    --ink: #0f172a;
    --muted: #64748b;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }
}

.shadow-custom {
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
}

.from-navy {
  --tw-gradient-from: var(--navy) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.to-indigo {
  --tw-gradient-to: var(--indigo) var(--tw-gradient-to-position);
}

.from-soft {
  --tw-gradient-from: var(--soft) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.to-white {
  --tw-gradient-to: #ffffff var(--tw-gradient-to-position);
}

.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

.bg-navy {
  background-color: var(--navy);
}

.bg-navy-2 {
  background-color: var(--navy-2);
}

.bg-soft {
  background-color: var(--soft);
}

.border-line {
  border-color: var(--line);
}

.text-ink {
  color: var(--ink);
}

.text-muted {
  color: var(--muted);
}

.text-indigo-2 {
  color: var(--indigo-2);
}

.border-indigo-2 {
  border-color: var(--indigo-2);
}

.bg-indigo-2\\/5 {
  background-color: rgba(99, 102, 241, 0.05);
}

.border-indigo-2\\/50 {
  border-color: rgba(99, 102, 241, 0.5);
}

/* Button styles */
.hover\\:bg-navy-2:hover {
  background-color: var(--navy-2);
}

.hover\\:-translate-y-0\\.5:hover {
  transform: translateY(-0.125rem);
}

.hover\\:bg-navy-2:hover {
  background-color: var(--navy-2);
}

.hover\\:text-ink:hover {
  color: var(--ink);
}

.hover\\:bg-soft:hover {
  background-color: var(--soft);
}

.hover\\:border-indigo-2\\/50:hover {
  border-color: rgba(99, 102, 241, 0.5);
}

.hover\\:bg-red-100:hover {
  background-color: rgb(254 226 226);
}

/* Focus styles */
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-indigo:focus {
  --tw-ring-color: var(--indigo);
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

/* Transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* Animations */
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .5;
  }
}

/* Placeholder styles */
.placeholder\\:text-muted::placeholder {
  color: var(--muted);
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,cAAc;AACd,oBAAoB;AACpB,mBAAmB;;AAEnB;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE;;gBAEY;IACZ,mCAAmC;IACnC,kCAAkC;EACpC;;EAEA;IACE;eACW;EACb;AACF;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,gEAAgE;EAChE,mEAAmE;EACnE,mEAAmE;AACrE;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,gEAAgE;EAChE,qEAAqE;EACrE,mEAAmE;AACrE;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA,kBAAkB;AAClB;EACE,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;AAC9F;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;EACxB,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,+FAA+F;EAC/F,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,WAAW;EACb;AACF;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n@layer base {\n  :root {\n    --navy: #1e3a8a;\n    --navy-2: #1e40af;\n    --indigo: #4f46e5;\n    --indigo-2: #6366f1;\n    --soft: #f8fafc;\n    --line: #e2e8f0;\n    --ink: #0f172a;\n    --muted: #64748b;\n  }\n\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n\n  body {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n      sans-serif;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  code {\n    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n      monospace;\n  }\n}\n\n.shadow-custom {\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n}\n\n.from-navy {\n  --tw-gradient-from: var(--navy) var(--tw-gradient-from-position);\n  --tw-gradient-to: rgb(30 58 138 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n}\n\n.to-indigo {\n  --tw-gradient-to: var(--indigo) var(--tw-gradient-to-position);\n}\n\n.from-soft {\n  --tw-gradient-from: var(--soft) var(--tw-gradient-from-position);\n  --tw-gradient-to: rgb(248 250 252 / 0) var(--tw-gradient-to-position);\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);\n}\n\n.to-white {\n  --tw-gradient-to: #ffffff var(--tw-gradient-to-position);\n}\n\n.bg-gradient-to-br {\n  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));\n}\n\n.bg-navy {\n  background-color: var(--navy);\n}\n\n.bg-navy-2 {\n  background-color: var(--navy-2);\n}\n\n.bg-soft {\n  background-color: var(--soft);\n}\n\n.border-line {\n  border-color: var(--line);\n}\n\n.text-ink {\n  color: var(--ink);\n}\n\n.text-muted {\n  color: var(--muted);\n}\n\n.text-indigo-2 {\n  color: var(--indigo-2);\n}\n\n.border-indigo-2 {\n  border-color: var(--indigo-2);\n}\n\n.bg-indigo-2\\/5 {\n  background-color: rgba(99, 102, 241, 0.05);\n}\n\n.border-indigo-2\\/50 {\n  border-color: rgba(99, 102, 241, 0.5);\n}\n\n/* Button styles */\n.hover\\:bg-navy-2:hover {\n  background-color: var(--navy-2);\n}\n\n.hover\\:-translate-y-0\\.5:hover {\n  transform: translateY(-0.125rem);\n}\n\n.hover\\:bg-navy-2:hover {\n  background-color: var(--navy-2);\n}\n\n.hover\\:text-ink:hover {\n  color: var(--ink);\n}\n\n.hover\\:bg-soft:hover {\n  background-color: var(--soft);\n}\n\n.hover\\:border-indigo-2\\/50:hover {\n  border-color: rgba(99, 102, 241, 0.5);\n}\n\n.hover\\:bg-red-100:hover {\n  background-color: rgb(254 226 226);\n}\n\n/* Focus styles */\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.focus\\:ring-2:focus {\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\n}\n\n.focus\\:ring-indigo:focus {\n  --tw-ring-color: var(--indigo);\n}\n\n.focus\\:border-transparent:focus {\n  border-color: transparent;\n}\n\n/* Transitions */\n.transition-all {\n  transition-property: all;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n.transition-colors {\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  transition-duration: 150ms;\n}\n\n/* Animations */\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: .5;\n  }\n}\n\n/* Placeholder styles */\n.placeholder\\:text-muted::placeholder {\n  color: var(--muted);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
